// ⚠️ AUTOMATICALLY GENERATED - DO NOT CHANGE
export const CHANNEL = '5f50bb1c-57c3-47af-b36a-392fe80f8803';

export const MAIN = 'M' + CHANNEL;
export const THREAD = 'T' + CHANNEL;
